import { Scissors } from 'lucide-react';

/**
 * Oct 2026 — compact "3-for-1 split Oct 2024" chip row shown above any
 * dividend table/chart whose amounts are split-adjusted, so a flat-looking
 * series is explained at a glance. `splits` comes from the backend
 * (`_recent_split_notes`, 6-year window). When `since` (ISO date of the
 * oldest visible row) is given and every split predates it, the chip stays
 * but the wording flips to "every row below is post-split".
 */
export default function SplitNote({ splits, since, suffix = '— all amounts below are split-adjusted', testId = 'split-note', className = '' }) {
  const all = (Array.isArray(splits) ? splits : []).filter((sp) => sp?.date);
  if (all.length === 0) return null;
  const inRange = since ? all.filter((sp) => sp.date >= since) : all;
  const list = inRange.length > 0 ? inRange : all.slice(-1);
  const text = inRange.length > 0 ? suffix : '— every row below is post-split; amounts are split-adjusted';
  return (
    <div
      className={`not-prose flex flex-wrap items-center gap-1.5 text-[11px] text-muted-foreground ${className}`}
      data-testid={testId}
      title="Per-share dividends before a split are adjusted to today's share count, so the figures compare like for like. Without that adjustment you would see a false dividend cut on the split date."
    >
      <Scissors className="w-3.5 h-3.5 text-amber-600 dark:text-amber-400" />
      {list.map((sp) => (
        <span
          key={sp.date}
          className="inline-flex items-center px-1.5 py-0.5 rounded border border-amber-300/60 bg-amber-50 dark:bg-amber-950/30 text-amber-800 dark:text-amber-300 font-semibold"
          data-testid={`${testId}-${sp.date}`}
        >
          {sp.label}
        </span>
      ))}
      <span>{text}</span>
    </div>
  );
}
